import { IconProps } from "../../../types/style";

const EditFillSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M15.98 3.5H8.02C4.57 3.5 2.5 5.56 2.5 9.02V16.97C2.5 20.44 4.57 22.5 8.02 22.5H15.97C19.43 22.5 21.49 20.44 21.49 16.98V9.02C21.5 5.56 19.43 3.5 15.98 3.5Z"
          fill={color}
        />
        <path
          d="M21.52 3.48028C19.73 1.68028 17.98 1.64028 16.14 3.48028L15.01 4.60028C14.91 4.70028 14.88 4.84028 14.92 4.97028C15.62 7.42028 17.58 9.38028 20.03 10.0803C20.06 10.0903 20.11 10.0903 20.14 10.0903C20.24 10.0903 20.34 10.0503 20.41 9.98028L21.52 8.86028C22.43 7.95028 22.88 7.08028 22.88 6.19028C22.88 5.29028 22.43 4.40028 21.52 3.48028Z"
          fill={color}
        />
        <path
          d="M18.3601 10.9198C18.0901 10.7898 17.8301 10.6598 17.5901 10.5098C17.3901 10.3898 17.1901 10.2598 17.0001 10.1198C16.8401 10.0198 16.6601 9.86984 16.4801 9.71984C16.4601 9.70984 16.4001 9.65984 16.3201 9.57984C16.0101 9.32984 15.6801 8.98984 15.3701 8.61984C15.3501 8.59984 15.2901 8.53984 15.2401 8.44984C15.1401 8.33984 14.9901 8.14984 14.8601 7.93984C14.7501 7.79984 14.6201 7.59984 14.5001 7.38984C14.3501 7.13984 14.2201 6.88984 14.1001 6.62984C13.9701 6.34984 13.8701 6.08984 13.7801 5.83984L8.4001 11.2198C8.0501 11.5698 7.7101 12.2298 7.6401 12.7198L7.2101 15.6998C7.1201 16.3298 7.2901 16.9198 7.6801 17.3098C8.0101 17.6398 8.4601 17.8098 8.9601 17.8098C9.0701 17.8098 9.1801 17.7998 9.2901 17.7898L12.2601 17.3698C12.7501 17.2998 13.4101 16.9698 13.7601 16.6098L19.1401 11.2298C18.8901 11.1498 18.6401 11.0398 18.3601 10.9198Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default EditFillSVG;
